import { AnalyticsEvent, AnalyticsEventCategories } from '../categories';

export class ChangelogOpened extends AnalyticsEvent {
  public readonly identification = AnalyticsEventCategories.CHANGELOG_OPENED;
}
